import { render, staticRenderFns } from "./v80a1060.vue?vue&type=template&id=4ab07fd6&scoped=true"
import script from "./v80a1060.vue?vue&type=script&lang=js"
export * from "./v80a1060.vue?vue&type=script&lang=js"
import style0 from "./v80a1060.vue?vue&type=style&index=0&id=4ab07fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab07fd6",
  null
  
)

export default component.exports